import { Box, CircularProgress } from "@mui/material";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { KeyDriveSecondaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDriveSecondaryButton";
import { KeyDrivePrimaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeydriveTextfield } from "../../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import { Cancel, CopyAll, Edit, Payment, Save } from "@mui/icons-material";
import { ICreditCardInformations, IPaymentInformation } from "../AccountAndSubscription";
import { useProfile } from "../../../../context/ProfileProvider/useProfile";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IAccountPaymentCard {
    editingCreditCardInfo: boolean;
    setEditingCreditCardInfo: (set: boolean) => void;
    setCreditCardInformations: (set: ICreditCardInformations) => void;
    creditCardInformations: ICreditCardInformations;
    contractId: string;
    cockpitContractId: string;
    paymentInformation: IPaymentInformation;
    loadingInformations: boolean;
    setOpenEditPaymentMethodModal: (set: boolean) => void;
}

export default function AccountPaymentCard({
    editingCreditCardInfo,
    setEditingCreditCardInfo,
    setCreditCardInformations,
    creditCardInformations,
    cockpitContractId,
    contractId,
    paymentInformation,
    loadingInformations,
    setOpenEditPaymentMethodModal
}: IAccountPaymentCard) {

    const profile = useProfile();
    const [customerPortalUrl, setCustomerPortalUrl] = useState<string>("");
    const [isCopied, setIsCopied] = useState(false);
    const { t } = useTranslation();

    async function copyTextToClipboard(text: string) {
        if ('clipboard' in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand('copy', true, text);
        }
    }

    function handleCopyClick(): void {
    copyTextToClipboard(customerPortalUrl)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

    return (
        <Box sx={{width: "100%"}}>
            { loadingInformations ? <CircularProgress /> : (
                <>
                        <KeyDriveBodyMax 
                            color="#000000"
                            needBold
                            needEllipses={false}
                            text={t("AccountAndSubscription.Payment")}
                        />
                        <Box
                            //maxWidth="620px"
                            minWidth="450px"
                            width="100%"
                            height="110px"
                            sx={{
                                border: "1px solid #EAEAEA",
                                borderRadius: "4px"
                            }}
                            marginTop="12px"
                        >
                            <Box
                                width="100%"
                                display="flex"
                                justifyContent="space-between"
                                paddingX="10px"
                                paddingTop="10px"
                            >
                                <KeyDriveSecondaryButton 
                                    TextComponent={KeyDriveBodyMin}
                                    TextComponentProps={{
                                        color: "",
                                        needBold: false,
                                        needEllipses: false,
                                        text: t("AccountAndSubscription.EditPaymentCard")
                                    }}
                                    startIcon={<Payment />}
                                    onClick={() => {
                                        setOpenEditPaymentMethodModal(true);
                                    }}
                                />
                                { customerPortalUrl != "" && (
                                    <KeyDriveSecondaryButton
                                        TextComponent={KeyDriveBodyMin}
                                        TextComponentProps={{
                                            color: "",
                                            needBold: false,
                                            needEllipses: false,
                                            text: `${isCopied ? t("AccountAndSubscription.Copy") : t("AccountAndSubscription.PaymentLinkGenerated")}`
                                        }}
                                        startIcon={<CopyAll />}
                                        onClick={() => {
                                            handleCopyClick();
                                        }}
                                        backgroundColor="#a3eda3ff"
                                    />
                                ) }
                            </Box>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                padding="10px"
                            >
                                <Box>
                                    <KeyDriveBodyMax 
                                        color="#969696"
                                        needBold={false}
                                        needEllipses={false}
                                        text={t("AccountAndSubscription.CardNumber")}
                                    />
                                    <KeyDriveBodyMin 
                                        color="#000000"
                                        needBold
                                        needEllipses={false}
                                        text={`**** **** **** ${paymentInformation?.cardNumber}`}
                                    />
                                </Box>
                                <Box>
                                    <KeyDriveBodyMax 
                                        color="#969696"
                                        needBold={false}
                                        needEllipses={false}
                                        text={t("AccountAndSubscription.ExpiresIn")}
                                    />
                                    <KeyDriveBodyMin 
                                        color="#000000"
                                        needBold
                                        needEllipses={false}
                                        text={`${paymentInformation?.expMonth}/${paymentInformation?.expYear}`}
                                    />
                                </Box>
                                <Box>
                                    <KeyDriveBodyMax 
                                        color="#969696"
                                        needBold={false}
                                        needEllipses={false}
                                        text="E-mail"
                                    />
                                    <KeyDriveBodyMin 
                                        color="#000000"
                                        needBold
                                        needEllipses={false}
                                        text={paymentInformation?.email}
                                    />
                                </Box>
                                <Box>
                                    <KeyDriveBodyMax 
                                        color="#969696"
                                        needBold={false}
                                        needEllipses={false}
                                        text="CVC"
                                    />
                                    <KeyDriveBodyMin 
                                        color="#000000"
                                        needBold
                                        needEllipses={false}
                                        text={creditCardInformations?.cvc}
                                    />
                                </Box>
                            </Box>
                        </Box>
                </>
            ) }
        </Box>
    );
}